import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";

import profileimage from "../../assets/profileimage.png";
import "../../pages/styles/PasswordReset.css";
import Icons from "../icons";
import useOnboarding from "../../hooks/useOnboarding";

const SetPasswordForm = () => {
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();

  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const password = watch("password");
  const location = useLocation();
  const navigate = useNavigate();
  const token = new URLSearchParams(location.search).get("token");

  const { submitPassword } = useOnboarding();

  useEffect(() => {
    if (!token) {
      navigate("/");
    }
  }, [token, navigate]);

  const onSubmit = async (data) => {
    setLoading(true);

    try {
      const result = await submitPassword(token, data.password);

      navigate("/congrats", {
        replace: true,
        state: { user: result || null },
      });
    } catch (error) {
      // unwrap() rejects with the thunk's rejectWithValue payload (a string).
      alert(
        (typeof error === "string" && error) ||
          error?.response?.data?.message ||
          error?.message ||
          "Something went wrong",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
   <div className="setup-profile">
        {/* LEFT SIDE */}
        <div className="left-panel">
          <img src={profileimage} alt="Setup Profile" className="profile-image" />
        </div>

      <div className="reset-right">
        <div className="absolute top-4 right-6 flex items-center gap-0 cursor-pointer">
          <Icons.Logo />
          <span className="text-xl font-semibold">QwickHub</span>
        </div>

        <div className="reset-card">
          <h1 className="reset-title title text-3xl font-semibold p-5">
            Set Your Password
          </h1>

          <form onSubmit={handleSubmit(onSubmit)}>
            <div>
              <label>Password</label>
              <div className="reset-password-field">
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="Enter your password"
                  {...register("password", {
                    required: "Password is required",
                    minLength: {
                      value: 8,
                      message: "Must be at least 8 characters",
                    },
                  })}
                />
                <span onClick={() => setShowPassword(!showPassword)}>
                  {showPassword ? <FaEye /> : <FaEyeSlash />}
                </span>
              </div>
              {errors.password && (
                <span className="reset-error">{errors.password.message}</span>
              )}
            </div>

            <div>
              <label>Confirm Password</label>
              <div className="reset-password-field">
                <input
                  type={showConfirmPassword ? "text" : "password"}
                  placeholder="Confirm your password"
                  {...register("confirmPassword", {
                    required: "Please confirm your password",
                    validate: (value) =>
                      value === password || "Passwords do not match",
                  })}
                />
                <span
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                >
                  {showConfirmPassword ? <FaEye /> : <FaEyeSlash />}
                </span>
              </div>
              {errors.confirmPassword && (
                <span className="reset-error">
                  {errors.confirmPassword.message}
                </span>
              )}
            </div>

            <div className="reset-links-row">
              <span className="reset-contact-text">
                Any Queries? Contact{" "}
                <a
                  href="https://qwickbit.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Qwickbit
                </a>
              </span>
            </div>

            <button type="submit" disabled={loading} className="reset-btn">
              {loading ? "Setting..." : "Set Password"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SetPasswordForm;
